import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Demo, UsuarioService } from '@app/services/usuario.service';

@Component({
  selector: 'dc-form-contact',
  templateUrl: './form-contact.component.html',
  styleUrls: ['./form-contact.component.scss']
})
export class FormContactComponent implements OnInit {
  solicitud: Demo = {
    IdEmpleado: 0,
    NumeroEmpleados: 0,
    NombreCompleto: '',
    Empresa: '',
    Provincia: '',
    Telefono: '',
    Email: '',
    PersonaContacto: '',
    Observaciones: '',
    SolicitaDemo: true,
    EnviarInfo: true
  };

  // observacionesTexto: string = '¿En qué podemos ayudarte?';
  loginForm: any;

  @ViewChild('nameInput') nameInput: ElementRef;

  focusLabel() {
    this.nameInput.nativeElement.focus();
  }

  @ViewChild('labelElement', { static: true }) labelElement!: ElementRef<
    HTMLLabelElement
  >;

  @ViewChild('inputElement', { static: true }) inputElement!: ElementRef<
    HTMLInputElement
  >;

  labelDefault: string = '¿En qué podemos ayudarte?';
  labelFocused = 'Mensaje';

  onInputFocus() {
    this.labelElement.nativeElement.textContent = this.labelFocused;
  }

  onInputBlur() {
    const inputValue = this.inputElement.nativeElement.value;
    this.labelElement.nativeElement.textContent = inputValue
      ? inputValue
      : this.labelDefault;
  }

  focusLabelText() {
    this.nameInput.nativeElement.focus();
  }

  constructor(
    private fb: FormBuilder,
    private usuarioService: UsuarioService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loginForm = this.fb.group({
      telefono: ['', Validators.required],
      empresa: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      nombre: ['', Validators.required],
      observaciones: ['', Validators.required],
      acceptTerms: [false]
    });

    // const label = document.querySelector("#myLabel");
    // label.addEventListener("click", () => {
    //   const input = label.nextElementSibling as HTMLInputElement;
    //   label.tabIndex = -1;
    //   input.focus();
    //   input.dispatchEvent(new Event("input"));
    // })
  }

  onLogin() {
    const formvalue = this.loginForm.value;

    if (this.loginForm.invalid) {
      if (this.loginForm.controls.email.errors.email) {
        alert('Inserte email válido');
      } else {
        alert('Rellene todos los campos');
      }
      console.log('this.loginForm ', this.loginForm);
      console.log(
        'this.loginForm email',
        this.loginForm.controls.email.errors.email
      );
      return;
    } else {
      console.log(formvalue);
      this.solicitud.Email = formvalue.email;
      this.solicitud.Empresa = formvalue.empresa;
      this.solicitud.Telefono = formvalue.telefono;
      this.solicitud.PersonaContacto = formvalue.nombre;
      this.solicitud.EnviarInfo = true;
      this.solicitud.SolicitaDemo = true;
      this.solicitud.Observaciones = formvalue.observaciones;
      this.solicitud.NumeroEmpleados = 0;
      this.solicitud.IdEmpleado = 0;
      this.solicitud.Provincia = 'Contacto HORAX3';
      this.solicitud.NombreCompleto = '';
      this.usuarioService
        .solicitaDemo(this.solicitud)
        .then(res => {
          console.log(res);
          if (res.TodoOk) {
            alert(
              'En la mayor brevedad posible contactaran con usted, gracias'
            );
            // if(confirm("Solicitud enviada correctamente, contactara con un usted un formador en la mayor brevedad posible")) {
            //   console.log("Implement delete functionality here");
            // }
          }

          this.loginForm.reset();
        })
        .catch(err => {
          console.error('*ERROR', err);
        });
      //   this.router.navigate(['/inicio']);
    }
  }
}
